export const WEBSITE_HISTORY_MISMATCH = 'account_history_mismatch';

export class WebsiteHistoryMismatchError extends Error {
  constructor() {
    super(WEBSITE_HISTORY_MISMATCH);
    this.name = 'WebsiteHistoryMismatchError';
  }
}

export function isWebsiteHistoryMismatch(error: unknown): boolean {
  return error instanceof WebsiteHistoryMismatchError;
}
